import axios from 'axios';
import { encode as base64_encode } from 'base-64';
import MaterialIcon from 'material-icons-react';
import React from 'react';
import { Button, Table } from 'react-materialize';
import { inserirCookie, retornarCookie } from '../../services/cookieservice';
import './SemAcessoPage.css';

const { REACT_APP_API, REACT_APP_URL_INSTANCE } = process.env;

export default class SemAcessoPage extends React.Component {
    state = {
        retornoCadastroIregular: undefined
    };

    componentDidMount() {

        setTimeout(() => {
            window.location.reload();
          }, 60000);
          
        document.body.style.overflow = "hidden";

        this.VerificarCadastroIrregular().then(() => {

            if (this.state.retornoCadastroIregular?.retorno === 'NAO') {

                const redirectTo = base64_encode('NavigationBar,HomePage');

                document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}&Auth=${base64_encode(
                    retornarCookie('Auth')
                )}`;
            }
        })
    }

    componentWillUnmount() {
        document.body.style.overflow = "initial";
    }

    VerificarCadastroIrregular = async () => {
        axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
        await axios
            .get(
                `${REACT_APP_API}agentevenda/VerificarCadastroIrregular?CdAgenteVendas=${retornarCookie('CdAgenteVendas')}&IdUsuario=${retornarCookie('IdUsuario')}`
            )
            .then((res) => {

                const retornoCadastroIregular = res.data;

                this.setState({ retornoCadastroIregular });
            });
    };

    render() {

        const nomeEmpresa = (idFilial) => {

            if (idFilial === "3") {
                return <a href="https://www.kipp.app.br/">Kipp</a>
            } else {
                return <a href="https://www.omint.com.br/minha-omint/login/">Omint</a>
            }
        }

        return (
            <div>

                <div className='row center errorArea blueBackground'>
                    <div className='CompanyName'>{nomeEmpresa(retornarCookie('Filial'))}</div>
                    <div className='errorHeader col s8 offset-s2 center-align'><span className='errorIcon'><MaterialIcon icon="highlight_off" color="white" /></span></div><br />
                    <div className='errorDescription col s8 offset-s2 center-align'>{this.state.retornoCadastroIregular?.retorno}</div>
                </div>
            </div>
        )
    }
}
